import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Select, Input, InputNumber, Space, Row, Col } from "antd";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

// import SelectUser from "./SelectUser";
// import SelectOrderCar from "./SelectOrderCar";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";
import * as String from "../commons/string";

import styles from "./Modal.module.css";

function ModalUpdateRentPayment({
    rent,
    rentPayment,
    open,
    onChangedOpen,
    onChangedPayment,
    onDeletedPayment,
}: {
    rent: Types.RentDto;
    rentPayment: Types.RentPaymentDto;
    open: boolean;
    onChangedOpen: (open: boolean) => void;
    onChangedPayment?: (value: any) => void;
    onDeletedPayment?: (payment: any) => void;
}) {
    const paymentMethod = [
        { type: "OFFLINE_BANK", label: String.offline_bank },
        { type: "OFFLINE_CARD", label: String.offline_card },
        { type: "OFFLINE_CASH", label: String.offline_cash },
    ];

    const { Option } = Select;
    const [form] = Form.useForm();
    const [isEtcPayment, setIsEtcPayment] = useState<boolean>(false);
    const [paymentCategories, setPaymentCategories] = useState<Array<Types.RentPaymentCategoryDto>>();
    const [currentCategory, setCurrentCategory] = useState<Types.RentPaymentCategoryDto>();
    // const [currentPaymentItem, setCurrentPaymentItem] = useState<Types.RentPaymentItemDto>();

    useEffect(() => {
        if (rentPayment?.memo?.includes("[기타]")) {
            setIsEtcPayment(true);
        }
    }, [rentPayment]);

    useEffect(() => {
        if (open === true) Utils.addModalStack();
        else Utils.popModalStack();

        form.resetFields();

        if (open) requestGetPaymentCategories();
    }, [open]);

    // useEffect(() => {
    //     form.setFieldsValue(rentPayment);
    //     form.setFieldValue("rentPaymentType", rentPayment.rentPaymentItem.rentPaymentCategory.rentPaymentCategoryId);
    //     form.setFieldValue("rentPaymentItem", rentPayment.rentPaymentItem.rentPaymentItemId);
    // }, [rentPayment]);

    useEffect(() => {
        form.setFieldsValue(rentPayment);
        form.setFieldValue("memo", rentPayment?.memo?.substring(4));
        form.setFieldValue("rentPaymentType", rentPayment?.rentPaymentItem?.rentPaymentCategory?.rentPaymentCategoryId);
        setCurrentCategory(
            paymentCategories?.find(
                (category) => category?.rentPaymentCategoryId === rentPayment?.rentPaymentItem?.rentPaymentCategory?.rentPaymentCategoryId
            )
        );

        form.setFieldValue("rentPaymentItem", rentPayment?.rentPaymentItem?.rentPaymentItemId);
    }, [paymentCategories]);

    const requestAxiosGetPaymentCategories = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_PAYMENT_CATEGORIES_URL);
        return response.data;
    };

    const {
        loading: loadingGetPaymentCategories,
        error: errorGetPaymentCategories,
        data: resultGetPaymentCategories,
        execute: requestGetPaymentCategories,
    } = useAsyncAxios(requestAxiosGetPaymentCategories);

    useEffect(() => {
        if (resultGetPaymentCategories === null) return;
        console.log("resultGetPaymentCategories", resultGetPaymentCategories);
        setPaymentCategories(resultGetPaymentCategories.rentPaymentCategories);
    }, [resultGetPaymentCategories]);

    useEffect(() => {
        if (errorGetPaymentCategories === null) return;
        console.log("errorGetPaymentCategories", errorGetPaymentCategories);
    }, [errorGetPaymentCategories]);

    const handleClose = () => {
        setIsEtcPayment(false);
        onChangedOpen(false);
    };

    const onFinish = (values: any) => {
        setIsEtcPayment(false);

        const payment: any = isEtcPayment
            ? {
                  rent: rent,
                  rentPaymentId: rentPayment.rentPaymentId,
                  amount: values.amount,
                  memo: "[기타]" + values.memo,
              }
            : {
                  rent: rent,
                  rentPaymentId: rentPayment.rentPaymentId,
                  basicPrice: values.basicPrice,
                  adjustedPrice: values.amount - values.basicPrice,
                  amount: values.amount,
              };

        if (onChangedPayment === undefined) {
            onChangedOpen(false);
        } else {
            onChangedPayment(payment);
        }
    };

    // useEffect(() => {
    //     if (currentPaymentItem !== undefined) {
    //         form.setFieldValue("basicPrice", Utils.getPaymentItemAmount(rent, currentPaymentItem));
    //         form.setFieldValue("amount", Utils.getPaymentItemAmount(rent, currentPaymentItem));
    //     }
    // }, [currentPaymentItem]);

    return (
        <Modal
            centered
            forceRender
            closable={false}
            className="login"
            open={open}
            title={isEtcPayment ? "기타" : "금액"}
            onOk={handleClose}
            onCancel={handleClose}
            footer={
                <Row gutter={8} style={{ width: "100%" }}>
                    <Col span={12} style={{ marginBottom: 8 }}>
                        <Button block key="back" onClick={handleClose}>
                            취소
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button block key="setPassword" type="primary" onClick={() => form.submit()}>
                            확인
                        </Button>
                    </Col>
                    {isEtcPayment && (
                        <Col span={24}>
                            <Button danger block onClick={() => onDeletedPayment && onDeletedPayment(rentPayment)}>
                                삭제
                            </Button>
                        </Col>
                    )}
                </Row>
            }
        >
            {isEtcPayment ? (
                <Form form={form} onFinish={onFinish}>
                    <Form.Item name="memo" label="등록명" className={styles.item}>
                        <Input.TextArea autoSize={{ minRows: 3 }} placeholder="등록명"></Input.TextArea>
                    </Form.Item>
                    <Form.Item name="amount" label="정산가" className={styles.item}>
                        <InputNumber placeholder="금액"></InputNumber>
                    </Form.Item>
                </Form>
            ) : (
                <Form form={form} onFinish={onFinish}>
                    <Form.Item name="basicPrice" label="기본 책정가" className={styles.item}>
                        <InputNumber disabled placeholder="금액"></InputNumber>
                    </Form.Item>
                    <Form.Item name="amount" label="최종 정산가" className={styles.item}>
                        <InputNumber placeholder="금액"></InputNumber>
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
}

export default ModalUpdateRentPayment;
